<template>
    <div class="index">
        <van-nav-bar title="退卡" left-text="返回" left-arrow @click-left="onClickLeft" />
        <div v-if="type==1">
            <van-form @submit="onSubmit" class="form">
                <van-field
                    v-model="changeForm.oldCar"
                    name="卡号"
                    label="卡号："
                    placeholder="卡号"
                    :rules="[{ required: true, message: '请填写卡号' }]"
                    @blur="oldcarBlur"
                />
                <van-field
                    v-model="changeForm.money"
                    name="余额"
                    label="余额："
                    placeholder="余额"
                    disabled
                />
                <div style="margin: 2rem 16px 1rem">
                    <van-button round block type="info" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </div>
        <div class="succeed" v-else>
            <van-icon name="checked" size="3rem" color="#4FB640" />
            <div class="text">退卡成功，余额会返回到您的账户</div>
            <van-button  style="margin-top:2rem;width:7rem;" round type="info" @click="toPath">返回首页</van-button>
        </div>
 
    </div>
</template>

<script>
 export default {
  data() {
    return {
        type:1,
        changeForm:{
            oldCar:'',
            money:'',
        }
    };
  },
   created() {
    },
  mounted(){
    
  },
  methods: {
    //   输入卡号后发送请求，请求余额
    oldcarBlur(){
        this.changeForm.money = 50
    },
    // 提交换卡申请
    onSubmit(){
        // this.$toast('退卡成功')
        this.type = 2
    },
       // 返回首页
    toPath(){
        this.$router.push({path:'/washingMachine/washClothes'})
    },
      //   后退
    onClickLeft(){
        this.$router.go(-1)
    }
    
  },
}
</script>
<style lang="less" scoped>
.index{
    .form{
        padding-top: 1rem;
        background-color: #fff;
        .van-field{
            font-size: 0.6rem;
        }
    }
    .succeed{
        padding-top: 4rem;
        .text{
            margin-top: 1rem;
            text-align: center;
            font-size: 0.7rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/washingMachine/carOut.vue